import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Home from "./component/common/Home";
import Game from "./component/Games/Game";
import Accelerators from "./component/pages/Accelerators/Accelerators";
import PortfolioCategoryPage from "./component/pages/Portfolio/PortfolioCategoryPage";
import "./App.css";
import { APIProvider } from "./contexts/APIProvider";
import { useContentProtection } from "./hooks/useContentProtection";

const App: React.FC = () => {
  useContentProtection();

  return (
    <div>
      <div className="appContainer">
        <APIProvider>
          <Router>
            <Routes>
              <Route path="/game" element={<Game />} />
              <Route path="/home" element={<Home />} />
              {/* <Route path="/accelerators" element={<Accelerators />} /> */}
              <Route
                path="/portfolio/:category"
                element={<PortfolioCategoryPage />}
              />
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </Router>
        </APIProvider>
      </div>
    </div>
  );
};

export default App;
